module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_arrow_top_white-12bcdcf6b8d479044e924854da943e36.svg";